import { useState } from "react";
import { useUser } from "../../../../context/UserContext";
import CopyIcon from "../../../../icon/CopyIcon";
import DownloadIcon from "../../../../icon/DownloadIcon";
import LogoutIcon from "../../../../icon/LogoutIcon";
import Card from "../../../Card/Card";
import classes from "./AccountDetails.module.css";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { formatAmount } from "../../../../utilities/functions";
import { env } from "../../../../constants/env";
import axios from "axios";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import useWindowDimensions from "../../../../hooks/getWindowDimensions";

export const InfoContainer = ({
  name,
  text,
  icon,
  className,
  textIconStyle,
}) => {
  return (
    <div
      className={`d-flex justify-content-between align-items-center ${classes.inputContainer} ${className}`}
    >
      <div className={classes.nameContainer}>{name}</div>
      <div
        className={`d-flex align-items-center  gap-2 ${classes.textContainer} ${textIconStyle}`}
      >
        {text}
        {icon}
      </div>
    </div>
  );
};

const AccountDetails = ({ setPayout, funded, amount, setShowOverlay }) => {
  const { user } = useUser();
  const [copyStatus, setCopyStatus] = useState("");
  const [showInvestorPass, setShowInvestorPass] = useState(false);
  const [showMasterPass, setShowMasterPass] = useState(false);

  const { height, width } = useWindowDimensions();

  const challengeDetailsList = [
    {
      name: "Initial balance",
      desc: `${formatAmount(amount)}`,
    },
    {
      name: "Plan type",
      desc: "Challenger",
    },
    {
      name: "Group trading",
      desc: "No",
    },
  ];

  const handleCopy = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopyStatus("Text copied!");
      toast.success("Text copied!")
    } catch (err) {
      console.error("Failed to copy text: ", err);
      setCopyStatus("Failed to copy text.");
    }
  };
  return (
    <div className="row">
      <div className={`col-md-${funded ? 10 : 12}`}>
        <Card
          className={`${classes.cardWrapper} d-flex justify-content-center align-items-center`}
        >
          <div className="row px-2 m-0 w-100">
            <div className="col-md-6 p-0 pe-md-1">
              <InfoContainer
                name="Login"
                text={user?.account?.accountId}
                icon={
                  <CopyIcon
                    onClick={() => handleCopy(user?.account?.accountId)}
                  />
                }
              />
            </div>
            <div className="col-md-6 mt-md-0 mt-2 p-0 ps-md-1">
              <InfoContainer
                name="Investor Pass."
                text={
                  showInvestorPass ? user?.account?.investorPassword : "•••••••"
                }
                icon={
                  <>
                    <div>
                      {showInvestorPass ? (
                        <IoEyeOutline
                          size={18}
                          color="#737373"
                          role="button"
                          onClick={() => setShowInvestorPass(false)}
                        />
                      ) : (
                        <IoEyeOffOutline
                          size={18}
                          color="#737373"
                          role="button"
                          onClick={() => setShowInvestorPass(true)}
                        />
                      )}
                    </div>
                    <CopyIcon
                      onClick={() =>
                        handleCopy(user?.account?.investorPassword)
                      }
                    />
                  </>
                }
              />
            </div>
            <div className="col-md-6 p-0 mt-2 pe-md-1">
              <InfoContainer
                name="Master Pass."
                text={
                  showMasterPass ? user?.account?.masterPassword : "•••••••"
                }
                icon={
                  <>
                    <div>
                      {showMasterPass ? (
                        <IoEyeOutline
                          size={18}
                          color="#737373"
                          role="button"
                          onClick={() => setShowMasterPass(false)}
                        />
                      ) : (
                        <IoEyeOffOutline
                          size={18}
                          color="#737373"
                          role="button"
                          onClick={() => setShowMasterPass(true)}
                        />
                      )}
                    </div>
                    <CopyIcon
                      onClick={() => handleCopy(user?.account?.masterPassword)}
                    />
                  </>
                }
              />
            </div>
            <div className="col-md-6 p-0 mt-2 ps-md-1">
              <InfoContainer
                name="MT5 Server"
                text={user?.account?.mt5Server}
                icon={<DownloadIcon  onClick={setShowOverlay}/>}
              />
            </div>
          </div>
          {(!funded &&  width > 768) && (
            <div
              className={`${classes.challengeDetails} d-flex flex-column gap-3`}
            >
              {challengeDetailsList.map((item, i) => (
                <div className="d-flex align-items-center gap-2" key={i}>
                  <IoIosCheckmarkCircleOutline color="#30970B" size={19} />
                  <div
                    className={classes.challengeDetailText}
                  >{`${item.name}: ${item.desc}`}</div>
                </div>
              ))}
            </div>
          )}
        </Card>
        {(!funded &&  width <= 768) && <Card
          className={`${classes.cardWrapper} mt-3`}
        >
          <div
              className={`d-flex flex-column gap-3`}
            >
              {challengeDetailsList.map((item, i) => (
                <div className="d-flex align-items-center gap-2" key={i}>
                  <IoIosCheckmarkCircleOutline color="#30970B" size={19} />
                  <div
                    className={classes.challengeDetailText}
                  >{`${item.name}: ${item.desc}`}</div>
                </div>
              ))}
            </div>
        </Card>}
      </div>
      {funded && (
        <div className="col-md-2 mt-3 mt-md-0">
          <Card
            className={`${classes.cardWrapper} d-flex flex-column justify-content-center align-items-center gap-2`}
          >
            <LogoutIcon
              color="#30970B"
              upRight={true}
              onClick={() => setPayout(true)}
            />
            <h5>Request payout</h5>
            <a href="#">Terms</a>
          </Card>
        </div>
      )}
    </div>
  );
};

export default AccountDetails;
